import { render, staticRenderFns } from "./previewTemp.vue?vue&type=template&id=977ef370&scoped=true"
import script from "./previewTemp.vue?vue&type=script&lang=js"
export * from "./previewTemp.vue?vue&type=script&lang=js"
import style0 from "./previewTemp.vue?vue&type=style&index=0&id=977ef370&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "977ef370",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('977ef370')) {
      api.createRecord('977ef370', component.options)
    } else {
      api.reload('977ef370', component.options)
    }
    module.hot.accept("./previewTemp.vue?vue&type=template&id=977ef370&scoped=true", function () {
      api.rerender('977ef370', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BaseTemplate/previewTemp.vue"
export default component.exports